const CONFIRMED_STATUS = "C"
const PENDING_STATUS = "U"

const SCHEDULE_STATUSES = {
  C: { symbol: "general#check", color: "rgb(139, 191, 105)" },
  U: { symbol: "general#question-circle", color: "rgb(254, 191, 43)" },
}

export { CONFIRMED_STATUS, PENDING_STATUS, SCHEDULE_STATUSES }
